import { ListingById, VehicleDetails } from "../../types/General";
import {
  TRANSMISSION_TYPE,
  VEHICLE_CONDITION,
  VEHICLE_TYPE,
} from "../../utils/enums";

type props = {
  type: any;
  details: VehicleDetails | undefined;
};

const BasicInformation = ({ type, details }: props) => {
  
  return (
    <>
      <div className="profileInfo_head">
        <h2>Basic Information</h2>
      </div>

      <div className="profileInfo_list">
        <ul className="text_info gap_p">
          <li className="w_50">
            <strong>Description</strong>
            <span>{details?.description?.en || "-"}</span>
          </li>
          <li className="w_50">
            <strong>Registration Number</strong>
            <span>{details?.registrationNumber || "-"}</span>
          </li>
          <li className="w_50">
            <strong>Condition</strong>
            <span>{details?.specs?.condition || "-"}</span>
          </li>
          <li className="w_50">
            <strong>Seats</strong>
            <span>{details?.specs?.seats?.toString() || "-"}</span>
          </li>
          <li className="w_50">
            <strong>Rental Policy (Min Days)</strong>
            <span>{details?.rentalPolicy?.daily?.minDays?.toString() || "-"}</span>
          </li>
          <li className="w_50">
            <strong>Rental Policy (Mileage Limit)</strong>
            <span>{details?.rentalPolicy?.daily?.mileageLimit?.toString() || "-"}</span>
          </li>
          <li className="w_50">
            <strong>Base Pricing (Currency)</strong>
            <span>{details?.basePricing?.currency?.toString() || "-"}</span>
          </li>
          <li className="w_50">
            <strong>Base Pricing (Daily)</strong>
            <span>{details?.basePricing?.daily?.toString() || "-"}</span>
          </li>
          <li className="w_50">
            <strong>Base Pricing (Security Charge)</strong>
            <span>{details?.basePricing?.securityCharge?.toString() || "-"}</span>
          </li>
          <li className="w_50">
            <strong>Base Pricing (Extra Mileage Charge)</strong>
            <span>{details?.basePricing?.extraMileageCharge?.toString() || "-"}</span>
          </li>
        </ul>
      </div>
    </>
  );
};

export default BasicInformation;
